import styled from '@emotion/styled';
import { Stack } from '@pairy/pds-react';

export const Container = styled(Stack)`
  border: 1px solid ${({ theme }) => theme.colors.zinc_200};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
`;
